import baseCommanderImg from "../assets/img/commanders/baseCommander/baseCommanderWhite.png"
import baseCommanderVideo from "../assets/video/commanders/baseCommander/baseCommander.mp4"

export const commanders = [
  {
    id: 1,
    name: "Base Commander",
    description:
      "Base Commander has no active skills or special abilities.\n" +
      "He passively increases the damage of all turret types. With each level, his damage bonus grows.",
    price: 700,
    image: baseCommanderImg,
    videoUrl: baseCommanderVideo,
    poster: baseCommanderImg,
    bonus: 5,
    type: "Commander",
    rarity: "common",
    level: 1,
    status: "mining",
    baseDamage: "+2% to all turret types",
    currentDamageBonus: "+2% to all turret types",
    actualDamage: "267",
    attackSpeed: "slow",
    attackType: "single",
    ability: "No special abilities",
  },
]
